import React, {useState} from 'react';
import Select from 'react-select';

const PillarContainerSummit = ({toggleVisibilityPillar, isVisiblePillar, commentPillar, commentTextAreaRefPillar, handleCommentChangePillar, togglePillarMarker,
          pillarMarker, pillarSave, ownerPillarData, handleChangeOwnerPillar, selectedOwnerPillar, pillarManuallySave, handleInputChangePillar, coordinatesManuallyPillae,
          toggleManualInput, manualInputEnabledPillar}) => {
            

  return (
    <React.Fragment>
  <button onClick={toggleVisibilityPillar} className={isVisiblePillar ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
    {isVisiblePillar ? 'Опора: скрыть' : 'Опора: показать'}
  </button>
  {isVisiblePillar && (
    <div className='divСommunicationsDrawer'>
      <img src='./pillar.png' width='30' height='30' style={{ marginRight: '5px' }} />
      <label className='textTitleDrawer'>Опора</label>
      <hr className="horizontalLineDrawer" />
      <div>
        <select
          className="selectStyleDrawer"
          style={{ marginTop: '10px' }}
          value={selectedOwnerPillar || ""}
          onChange={handleChangeOwnerPillar}
        >
          <option value="">Собственник</option>
          {ownerPillarData.map((ownerPillar) => (
            <option key={ownerPillar.id} value={`${ownerPillar.id}`}>
              {ownerPillar.name}
            </option>
          ))}
        </select>
        <hr className="horizontalLineDrawer" style={{ marginTop: '10px' }} />
      </div>
      <div>
        <textarea
          className='areaDescriptionDrawer'
          placeholder="Комментарий"
          rows={3}
          cols={44}
          value={commentPillar || ""}
          ref={commentTextAreaRefPillar}
          onChange={handleCommentChangePillar}
        />
        <div style={{ marginTop: '10px' }}>
          <label>
            <input
            style={{ color: 'lightgray' }}
              type="checkbox"
              checked={manualInputEnabledPillar}
              onChange={toggleManualInput}
            />{' '}
            <span style={{color: "lightgrey"}}>Внести вручную</span>
          </label>
        </div>
        <hr className="horizontalLineDrawer" style={{ marginTop: '10px' }} />
        {manualInputEnabledPillar ? (
          <>
          <input
            className='inputAuth'
            type="text"
            placeholder="формат 50.4488, 30.5255"
            value={coordinatesManuallyPillae}
            onChange={handleInputChangePillar}
            style={{ width: '300px', marginTop: '5px' }}
          />
          <button 
            onClick={pillarManuallySave} style={{ marginLeft: '5px', marginTop: '0px'}}
            className="buttonSaveDrawer"
          >
            Сохранить
          </button>
       </>
        ) : (
          <>
            <button
              onClick={togglePillarMarker}
              className={pillarMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}
            >
              {pillarMarker ? 'Завершить' : 'Добавить'}
            </button>

             <button
              onClick={pillarSave}
              className="buttonSaveDrawer"
             >
              Сохранить
           </button>
           </>
          )}





      </div>
    </div>
  )}
</React.Fragment>
    // <React.Fragment>
    //   <button onClick={toggleVisibilityPillar} className={isVisiblePillar ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
    //     {isVisiblePillar ? 'Опора: скрыть' : 'Опора: показать'}
    //   </button>
    //   {isVisiblePillar && (
    //     <div className='divСommunicationsDrawer'>
    //       <img src='./pillar.png' width='30' height='30' style={{ marginRight: "5px" }}/>
    //       <label className='textTitleDrawer'>Опора</label>
    //       <hr className="horizontalLineDrawer"/>
    //       <div>

    //          <select className="selectStyleDrawer" style={{marginTop: "10px"}} value={selectedOwnerPillar} onChange={handleChangeOwnerPillar} >
    //                <option value="">Собственник</option>
    //                {ownerPillarData.map(ownerPillar => (
    //                   <option key={ownerPillar.id} value={`${ownerPillar.id}`}>{ownerPillar.name}</option>
    //                ))}
    //          </select>

    //       <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }}/>
    //       </div>
    //       <div>

    //         <textarea
    //           className='areaDescriptionDrawer'
    //           placeholder="Комментарий"
    //           rows={3}
    //           cols={44}
    //           value={commentPillar}
    //           ref={commentTextAreaRefPillar}
    //           onChange={handleCommentChangePillar}
    //         />
    //         <button onClick={togglePillarMarker} className={pillarMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
    //           {pillarMarker ? 'Завершить' : 'Добавить'}
    //         </button>
    //         <button onClick={pillarSave} className='buttonSaveDrawer'>Сохранить</button>
    //       </div>
    //     </div>
    //   )}
    // </React.Fragment>
  );
};

export default PillarContainerSummit;